<template>
  <div>
    <my-header></my-header>

    <div class="player-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="player-content-box">
        <h2>
          Игрок {{ playerId }}

          <b-badge v-if="isQA" variant="primary" class="mr-1">QA</b-badge>
          <b-badge v-if="isBanned" variant="danger" class="mr-1">Banned</b-badge>
          <b-badge v-if="isEventAccessBlocked" variant="warning" class="mr-1">Events blocked</b-badge>
        </h2>

        <router-view
          @event-access-status-updated="updateEventAccessStatus"
          @player-banned="handlePlayerBannded"
          @player-unbanned="handlePlayerUnbannded"
        />
      </div>
    </div>

  </div>
</template>

<script>
import auth from '../auth.js';
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { isPlayerBanned } from '../model/player_ban.js';

import { isEventAccessBlocked } from '../model/event_access.js';

import { mayEditPlayerData  as utilMayEditPlayerData  } from '../util.js';
import { mayReadUserActions as utilMayReadUserActions } from '../util.js';
import { hasRouteByName                               } from '../util.js';

import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'Player',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadingStatus: LOADING_STATUS__INIT,

      player: null,

      nowSec: Date.now() / 1000,
    };
  },

  computed: {

    /** @returns {Object[]} */
    menuItems() {
      const thisObj = this;

      const items = [
        {
          title: 'Info',
          route: {name: 'player_info', params: {playerId: this.playerId}},
          exact: true,
        },
        {
          title: 'Client identities',
          route: {name: 'player_client_identities', params: {playerId: this.playerId}},
        },
        {
          title: 'Restorations',
          route: {name: 'player_restorations', params: {playerId: this.playerId}},
        },
        {
          title: 'Payment intents',
          route: {name: 'player_payment_intents', params: {playerId: this.playerId}},
        },
        {
          title: 'Client payments',
          route: {name: 'player_client_payments', params: {playerId: this.playerId}},
        },
        {
          title: 'Billing',
          route: {name: 'player_billing', params: {playerId: this.playerId}},
        },
        {
          title: 'Pendings',
          route: {name: 'player_pendings', params: {playerId: this.playerId}},
        },
        {
          title: 'Inventory',
          route: {name: 'player_inventory', params: {playerId: this.playerId}},
        },
        {
          title: 'Resource log',
          route: {name: 'player_resource_log', params: {playerId: this.playerId}},
        },
        {
          title: 'Resource log copies',
          route: {name: 'player_resource_log_copies', params: {playerId: this.playerId}},
        },
        {
          title: 'App sessions',
          route: {name: 'player_app_sessions_log', params: {playerId: this.playerId}},
        },
        {
          title: 'Net sessions',
          route: {name: 'player_net_sessions_log', params: {playerId: this.playerId}},
        },
        {
          title: 'Limits',
          route: {name: 'player_limits', params: {playerId: this.playerId}},
        },
        {
          title: 'Level finished events',
          route: {name: 'player_level_finished_events', params: {playerId: this.playerId}},
        },
        {
          title: 'Events',
          route: {name: 'player_events', params: {playerId: this.playerId}},
          isActive() {
            const matchedRoutes = thisObj.$route.matched;
            const PLAYER_EVENTS_ROUTE_NAME = 'player_events';

            return hasRouteByName(matchedRoutes, PLAYER_EVENTS_ROUTE_NAME);
          },
        },
        {
          title: 'Contest metrics',
          route: {name: 'player_contest_log', params: {playerId: this.playerId}},
        },
        //{
        //  title: 'Contest rewards',
        //  route: {name: 'player_contests_rewards', params: {playerId: this.playerId}},
        //},
        {
          title: 'Win streaks',
          route: {name: 'player_win_streaks', params: {playerId: this.playerId}},
        },
        {
          title: 'Gifts from others',
          route: {name: 'player_club_gifts', params: {playerId: this.playerId}},
        },
        {
          title: 'Complaints from others',
          route: {name: 'player_in_complaints', params: {playerId: this.playerId}},
        },
        {
          title: 'Chat block log',
          route: {name: 'player_chat_block_log', params: {playerId: this.playerId}},
        },
        {
          title: 'Equipment',
          route: {name: 'player_equipment', params: {playerId: this.playerId}},
        },
        {
          title: 'Offers',
          route: {name: 'player_offers', params: {playerId: this.playerId}},
        },
        {
          title: 'Ads log',
          route: {name: 'player_ads', params: {playerId: this.playerId}},
        },
        {
          title: 'Orders',
          route: {name: 'player_orders', params: {playerId: this.playerId}},
        },
        {
          title: 'Level decrements',
          route: {name: 'player_level_decrements', params: {playerId: this.playerId}},
          exact: true,
        },
        {
          title: 'Emergency state log',
          route: {name: 'player_emergency_state_log', params: {playerId: this.playerId}},
          exact: true,
        },
        {
          title: 'Device token info',
          route: {name: 'player_device_token_info', params: {playerId: this.playerId}},
        },
        {
          title: 'State',
          route: {name: 'player_state', params: {playerId: this.playerId}},
          exact: true,
        },
      ];

      if(this.mayEditPlayerData) {
        items.push({
          title: 'State editor',
          route: {name: 'player_state_editor', params: {playerId: this.playerId}},
        });
      }

      if(this.mayEditPlayerData) {
        items.push({
          title: 'System',
          route: {name: 'player_system', params: {playerId: this.playerId}},
        });
      }

      items.push({
        title: 'Ban log',
        route: {name: 'player_ban_log', params: {playerId: this.playerId}},
      });

      if(this.mayReadUserActions) {
        items.push({
          title: 'Users actions',
          route: {name: 'player_users_actions', params: {playerId: this.playerId}},
        });
      }

      return items;
    },

    /** @returns {boolean} */
    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },

    /** @returns {boolean} */
    mayReadUserActions() {
      return utilMayReadUserActions(this.actor.role);
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isQA() {
      if(!this.isLoadedNormal) {
        return false;
      }

      return this.player.isQA;
    },

    /** @returns {boolean} */
    isBanned() {
      if(!this.isLoadedNormal) {
        return false;
      }
  
      return isPlayerBanned(this.player.banData, this.nowSec);
    },

    /** @returns {boolean} */
    isEventAccessBlocked() {
      if(!this.isLoadedNormal) {
        return false;
      }

      return isEventAccessBlocked(this.player.eventAccessStatus);
    },
  },

  created() {
    this.loadPlayer();
  },

  methods: {
    loadPlayer() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/player/${this.playerId}/short_info`;

      HTTP.get(url)
      .then(response => {
        this.player = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    updateEventAccessStatus(newValue) {
      this.player.eventAccessStatus = newValue;
    },

    handlePlayerBannded(banFtime) {
      const newBanData = {
        isBanned: true,
        ftime: banFtime,
      };

      this.player.banData = newBanData;
    },

    handlePlayerUnbannded() {
      this.player.banData = null;
    },
  },
}
</script>

<style scoped>
.player-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.player-content-box {
  min-width: 600px;
  padding-top: 1em;
}
</style>
